import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ReviewList = ({ reviews }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    swipe: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="px-6 sm:px-12">
      <Slider {...settings}>
        {reviews.map((r) => (
          <div key={r.id} className="px-3">
            <div className="bg-slate-800 text-white p-6 rounded-xl shadow-xl min-h-[250px] flex flex-col justify-between">
              <div>
                <h4 className="font-bold text-lg mb-2">{r.name}</h4>
                <div className="flex mb-3">
                  {[...Array(5)].map((_, i) => (
                    <span
                      key={i}
                      className={`text-lg ${
                        i < r.rating ? 'text-yellow-400' : 'text-gray-600'
                      }`}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {r.comment}
                </p>
              </div>
              <p className="text-xs text-gray-400 mt-4 self-end">
                {new Date(r.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ReviewList;
